
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[origin]/ISR/[[...slug]]",
      function () {
        return require("private-next-pages/_sites/[origin]/ISR/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/[origin]/ISR/[[...slug]]"])
      });
    }
  